// initial state
const initialState = {
    data: ''
}

// type
const SEARCH_DATA = 'SEARCH_DATA';

// reducer
const searchReducer = (state=initialState, action) => {
    switch(action.type){
        case 'SEARCH_DATA': return {
            data: action.payload
        }
        default: return state;
    }
}

// action
const searchAction = (text) => async ( dispatch, getState ) => {
    dispatch({
        type: SEARCH_DATA,
        payload: text
    });
}

// export
export { searchAction }

export default searchReducer;
